export enum LocalStorageKeysOrders {
  DateDelivery = "dateDelivery",
  CNPJFromNewOrder = "cnpjFromNewOrder",
  isOrderFromNewRequest = "isOrderFromNewRequest",
}
